<template>
<f7-page class="chef-view" :page-content="false">
  <template #fixed>
    <app-navbar :back="false"/>
  </template>

  <div class="chef-intro">
    <div class="title">FIRST TASTE OF SPRING</div>
    <div class="desc">The inflight menu is the quintessential Thales experience. A culinary journey from our chef de cuisine comprised of four courses that evolve based on seasonality, showcasing various techniques, preparations, and creativity. This season, we are proud to feature local seafood and seasonal produce from our organic farm in Bourdeau.</div>
    <f7-button fill round href="/journey">Meal Selection</f7-button>
  </div>

  <video class="chef-video"
    src="@/assets/videos/ahq-11.mp4"
    controls autoplay disablepictureinpicture controlslist="nodownload nofullscreen noremoteplayback"/>
</f7-page>
</template>

<script>
import AppNavbar from '@/components/AppNavbar'

export default {
  components: { AppNavbar }
}
</script>

<style lang="scss" scoped>
.chef-view {
  .chef-intro {
    position: absolute; top: calc(var(--f7-navbar-height) + 500px); left: 0;
    width: 100%; height: calc(100% - var(--f7-navbar-height) - 500px);
    display: flex; flex-direction: column; justify-content: center; align-items: center;
    text-align: center;
    padding: 0 200px;
    box-sizing: border-box;
    .title { font-size: 30px; font-weight: bold; margin-bottom: 60px; }
    .desc { font-size: 24px; margin-bottom: 80px; }
  }
  .chef-video {
    position: absolute; top: var(--f7-navbar-height); left: 0;
    width: 100%; height: 500px;
    display: block;
    background: #333;
  }

  @include media-landscape {
    .chef-intro {
      top: 0;
      width: 50%; height: 100%;
      padding: 0 100px;
    }
    .chef-video {
      top: 0; right: 0; left: auto;
      width: 50%; height: 100%;
    }
  }
}
</style>
